import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M10 16.666c1.847 0 3.42-.65 4.719-1.948 1.298-1.299 1.948-2.871 1.948-4.719 0-1.847-.65-3.42-1.948-4.718C13.42 3.982 11.847 3.333 10 3.333c-1.847 0-3.42.649-4.719 1.948-1.298 1.298-1.948 2.871-1.948 4.718 0 1.848.65 3.42 1.948 4.72 1.299 1.298 2.872 1.947 4.72 1.947Zm3.917-3.917-1.167 1.167-3.583-3.583v-4.5h1.666v3.833l3.084 3.083Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M6.75 17.676a8.115 8.115 0 0 0 3.25.657 8.115 8.115 0 0 0 3.25-.657 8.415 8.415 0 0 0 2.646-1.78 8.416 8.416 0 0 0 1.781-2.647 8.114 8.114 0 0 0 .656-3.25 8.115 8.115 0 0 0-.656-3.25 8.416 8.416 0 0 0-1.781-2.645 8.415 8.415 0 0 0-2.646-1.782A8.115 8.115 0 0 0 10 1.666a8.115 8.115 0 0 0-3.25.656 8.415 8.415 0 0 0-2.646 1.782 8.415 8.415 0 0 0-1.781 2.645A8.115 8.115 0 0 0 1.667 10c0 1.153.218 2.236.656 3.25a8.416 8.416 0 0 0 1.781 2.646 8.415 8.415 0 0 0 2.646 1.781Zm7.969-2.958c-1.299 1.299-2.872 1.948-4.719 1.948-1.847 0-3.42-.65-4.719-1.948C3.983 13.42 3.333 11.847 3.333 10s.65-3.42 1.948-4.718c1.299-1.299 2.872-1.948 4.72-1.948 1.846 0 3.42.649 4.718 1.948C16.017 6.58 16.667 8.153 16.667 10c0 1.848-.65 3.42-1.948 4.72Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }